var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-wrap"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{style:({
        height: "100vh",
        overflow: 'hidden'
      })},[_c('div',{style:({
          height: _vm.bodyHeight || '1620px',
          'transformOrigin':'left top',
          'transform':("scale(" + _vm.scalseNum + ")"),
          '-webkit-transform':("scale(" + _vm.scalseNum + ")"),
          '-moz-transform':("scale(" + _vm.scalseNum + ")"),
          '-o-transform':("scale(" + _vm.scalseNum + ")"),
          '-ms-transform':("scale(" + _vm.scalseNum + ")")
        })},[_c('div',{attrs:{"id":"CoolSuperScreen"}},[_c('div',{staticClass:"screen-wrap"},[_c('div',{staticClass:"screen-1"},[_c('div',{staticClass:"screen-1__content"},[_c('ScreenFirst',{attrs:{"data":_vm.ScreenFirstData}})],1)]),_c('div',{staticClass:"screen-2"},[_c('div',{staticClass:"screen-2__content"},[_c('ScreenSecond',{attrs:{"screen-second-data":_vm.ScreenSecondData}})],1)]),_c('div',{staticClass:"screen-3"},[_c('div',{staticClass:"screen-3__content"},[_c('ScreenThree',{attrs:{"data":_vm.ScreenThreeData}})],1)])])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }